module.exports = __webpack_public_path__ + "static/media/bigpic-sub-02.ecba099b.jpg";